/* type/value/ensure.js */ function _(require, module, exports) {
    var resolveException = require(74) /* ../lib/resolve-exception */, is = require(29) /* ./is */;
    module.exports = function (value /*, options*/) {
        if (is(value))
            return value;
        return resolveException(value, "Cannot use %v", arguments[1]);
    };
}
